import {
    allToolSignatures,
    webSearchToolSignature,
    userSelectionDisplayToolSignature,
    displayProfilesToolSignature,
    displayPlaybooksToolSignature,
    displayConversationToolSignature,
    createPlaybookToolSignature,
    getProspectsInfoToolSignature,
    searchMyAssignedContactsToolSignature,
    updatePlaybooksToolSignature,
    thinkToolSignature,
    searchLinkedinNetworkRegexToolSignature,
    getInsideNetworkRecommendationsToolSignature,
} from '@andsend/services-agent-shared';
import { AutoRegisterToolUIs } from './auto-register-tool-ui';
import { WebSearchToolUI } from './web-search-tools-ui';
import {
    DisplayProfilesToolUI,
    GetInsideNetworkRecommendationsToolUI,
    GetProspectsInfoToolUI,
    SearchLinkedinNetworkToolUI,
    SearchMyAssignedContactsToolUI,
} from './display-profiles-tools-ui';
import { UserSelectionToolUI } from './user-selection-tool-ui';
import { CreatePlaybookToolUI, DisplayPlaybooksToolUI, UpdatePlaybookToolUI } from './display-playboooks-tool-ui';
import { DisplayActionsToolUI } from './display-actions-tool-ui';
import { ThinkingToolUI } from './thinking-tool-ui';
import { UpdateWorkingMemoryToolUI } from './working-memory-tools-ui';
import { DisplayErrorToolUI } from './display-error';

// Map of custom tool UI components for specific tools
// For tools that don't have a custom UI, a generic UI will be created if they have a toolCallUi function
const customToolUIs = {
    [webSearchToolSignature.name]: WebSearchToolUI,
    [displayPlaybooksToolSignature.name]: DisplayPlaybooksToolUI,
    [displayProfilesToolSignature.name]: DisplayProfilesToolUI,
    [searchMyAssignedContactsToolSignature.name]: SearchMyAssignedContactsToolUI,
    [getInsideNetworkRecommendationsToolSignature.name]: GetInsideNetworkRecommendationsToolUI,
    [displayConversationToolSignature.name]: DisplayActionsToolUI,
    [userSelectionDisplayToolSignature.name]: UserSelectionToolUI,
    [createPlaybookToolSignature.name]: CreatePlaybookToolUI,
    [updatePlaybooksToolSignature.name]: UpdatePlaybookToolUI,
    // [searchLinkedinNetworkToolSignature.name]: SearchLinkedinNetworkToolUI,
    [searchLinkedinNetworkRegexToolSignature.name]: SearchLinkedinNetworkToolUI,
    [getProspectsInfoToolSignature.name]: GetProspectsInfoToolUI,
    [thinkToolSignature.name]: ThinkingToolUI,
    updateWorkingMemory: UpdateWorkingMemoryToolUI,
    displayError: DisplayErrorToolUI,
};

/**
 * A component that registers UIs for all tool signatures.
 * This component can be used in the AgentChat component to register all tool UIs at once.
 */
export const AllToolsUI = () => {
    return <AutoRegisterToolUIs toolSignatures={allToolSignatures} customToolUIs={customToolUIs} />;
};
